import React from "react";
import "./SummaryCards.scss"; 

const SummaryCards = ({cards}) => {
function capitalizeEachWord(text) {
  if (!text || typeof text !== "string" || text.trim() === "") {
    return "--";
  }
  return text.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
}


  return (
    <div className="summary-cards">
      {cards.map((card, idx) => (
        <div key={idx} className="summary-card active">
<div className="Icon_titles">
          <div className="icon-box">
            <img src={card.icon}/>
          </div>
<div>
<div className="title">{capitalizeEachWord(card.title)}</div>
</div>
    </div>
          <div className="Content_names">
            <div className="label">{card.label}</div>
            <div className="count">{card.count}</div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SummaryCards;
